export const MIN_ABOUT_LENGTH = 10;
export const MAX_ABOUT_LENGTH = 500;
